import { Link } from "react-router-dom";
import {
  ArrowRight,
  ArrowUpRight,
  Compass,
  Building2,
  Key,
  Blocks,
  ClipboardList,
  Recycle,
} from "lucide-react";
import PageHeader from "@/components/PageHeader";
import { useDocumentSEO } from "@/hooks/useDocumentSEO";

const BOLUMLER = [
  {
    slug: "mimari-projeler",
    idx: "01",
    icon: Compass,
    title: "Mimari Projeler",
    lead:
      "Konsept aşamasından uygulama projesine kadar mimari projelendirme hizmetleri.",
    body: [
      "Konsept aşamasından uygulama projesine kadar bütün mimari projelendirme sürecini bütüncül bir bakışla yönetiyoruz.",
      "Mekân kurgusu, işlev, malzeme ve maliyet dengesini birlikte gözeterek; tasarım kararlarını üretim ve uygulamayla uyumlu biçimde şekillendiriyoruz.",
      "Amacımız, hem mimari değer taşıyan hem de sahaya sorunsuz aktarılabilen projeler ortaya çıkarmaktır.",
    ],
    highlights: ["Konsept Tasarım", "Uygulama Projesi", "Malzeme &amp; Detay"],
    image:
      "https://images.pexels.com/photos/834892/pexels-photo-834892.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    imageAlt: "Mimari çizim ve plan üzerinde çalışma",
  },
  {
    slug: "insaat-taahhut",
    idx: "02",
    icon: Building2,
    title: "İnşaat Taahhüt",
    lead:
      "Konut, ticari ve karma kullanım projelerinde taahhüt kapsamında inşaat uygulama hizmetleri.",
    body: [
      "Konut, ticari ve karma kullanım projelerinde taahhüt kapsamında inşaat uygulama hizmetleri sunuyoruz.",
      "Süreci; kapsam, bütçe ve program disiplini içinde, izlenebilir bir yönetim anlayışıyla yürütüyoruz.",
      "Saha koordinasyonundan kalite kontrolüne kadar tüm aşamalar tek bir kurumsal çatı altında planlanır.",
    ],
    highlights: ["Konut", "Ticari &amp; Karma", "Saha Yönetimi"],
    image:
      "https://images.pexels.com/photos/159306/construction-site-build-construction-work-159306.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    imageAlt: "İnşaat şantiye sahası",
  },
  {
    slug: "anahtar-teslim",
    idx: "03",
    icon: Key,
    title: "Anahtar Teslim Projeler",
    lead:
      "Tasarımdan teslimata kadar tüm süreçlerin tek elden, planlı şekilde yönetildiği çözümler.",
    body: [
      "Tasarımdan teslimata kadar tüm süreçlerin tek elden yönetildiği bütüncül anahtar teslim çözümler geliştiriyoruz.",
      "Kararların erken aşamada mimarlık, uygulama ve maliyet perspektiflerini birlikte değerlendirdiği bir kurgu; iş sahibi için sadeleştirilmiş bir muhataplık ve netleşmiş bir sorumluluk zinciri sağlar.",
      "Süreç boyunca önceliğimiz; projeye başlangıçta söz verdiğimiz nitelikle ulaşmasıdır.",
    ],
    highlights: ["Tek Sorumluluk", "Bütüncül Kurgu", "Zaman &amp; Bütçe"],
    image:
      "https://images.pexels.com/photos/302769/pexels-photo-302769.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    imageAlt: "Modern bina dış cephesi",
  },
  {
    slug: "gayrimenkul-gelistirme",
    idx: "04",
    icon: Blocks,
    title: "Gayrimenkul Geliştirme",
    lead:
      "Arsa/proje değerlendirmesinden geliştirme sürecine kadar yatırım odaklı gayrimenkul geliştirme hizmetleri.",
    body: [
      "Arsa değerlendirmesinden proje geliştirme ve pazara sunuma kadar yatırım odaklı gayrimenkul geliştirme çalışmaları yürütüyoruz.",
      "Fizibilite, konum analizi ve programlama aşamalarında mimari değer ile ticari verimliliği birlikte kurgularız.",
      "Amacımız; kısa vadeli çıktı yerine uzun soluklu değeri gözeten geliştirme kararlarına destek olmaktır.",
    ],
    highlights: ["Fizibilite", "Konum Analizi", "Değer Kurgusu"],
    image:
      "https://images.pexels.com/photos/374870/pexels-photo-374870.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    imageAlt: "Şehir silüeti",
  },
  {
    slug: "proje-yonetimi",
    idx: "05",
    icon: ClipboardList,
    title: "Proje Yönetimi ve Danışmanlık",
    lead:
      "Bütçe, süre ve kalite dengesini gözeten profesyonel proje yönetimi ve danışmanlık hizmetleri.",
    body: [
      "Bütçe, süre ve kalite dengesini gözeten profesyonel proje yönetimi ve danışmanlık hizmetleri sunuyoruz.",
      "Süreci; şeffaf raporlama, düzenli koordinasyon ve karar noktalarında net değerlendirmelerle işletiyoruz.",
      "Danışmanlık desteklerimiz; hem kendi geliştirdiğimiz projelerde hem de talep hâlinde üçüncü taraflara yönelik olarak yapılandırılabilir.",
    ],
    highlights: ["Şeffaf Raporlama", "Koordinasyon", "Karar Desteği"],
    image:
      "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    imageAlt: "Toplantı, plan ve rapor",
  },
  {
    slug: "yapi-yenileme",
    idx: "06",
    icon: Recycle,
    title: "Yapı Yenileme ve Dönüşüm",
    lead:
      "Mevcut yapıların güçlendirilmesi, yenilenmesi ve kentsel dönüşüm kapsamındaki uygulamalar.",
    body: [
      "Mevcut yapıların güçlendirilmesi, yenilenmesi ve kentsel dönüşüm kapsamındaki uygulamaları planlı bir yaklaşımla ele alıyoruz.",
      "Yapının mevcut değerini koruyup öne çıkaran kararlarla; bugünün konfor, güvenlik ve enerji standartlarına uygun bir yeniden kullanım öneriyoruz.",
      "Süreç, hukuki ve teknik zeminin baştan netleştirildiği bir çerçeveyle yürütülür.",
    ],
    highlights: ["Güçlendirme", "Yenileme", "Kentsel Dönüşüm"],
    image:
      "https://images.pexels.com/photos/1029615/pexels-photo-1029615.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    imageAlt: "Yapı yenileme",
  },
];

/**
 * A single detailed activity area section — zigzag layout, alternates
 * light/dark and image side. Preserves anchor id for hash-scroll.
 */
function AlanBolumu({ bolum, index }) {
  const isDark = index % 2 === 1;
  const imageOnLeft = index % 2 === 0;
  const Icon = bolum.icon;

  return (
    <section
      id={bolum.slug}
      data-testid={`faaliyet-bolum-${bolum.slug}`}
      className={`scroll-mt-24 ${
        isDark ? "bg-anthracite text-white" : "bg-white text-navy"
      } py-20 lg:py-28 relative overflow-hidden`}
    >
      {isDark && (
        <div className="absolute inset-0 blueprint-grid opacity-25 pointer-events-none" />
      )}

      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        {/* Image */}
        <div
          className={`md:col-span-5 ${
            imageOnLeft ? "md:col-start-1" : "md:col-start-8"
          }`}
        >
          <div className="relative overflow-hidden">
            <img
              src={bolum.image}
              alt={bolum.imageAlt}
              loading="lazy"
              className="w-full h-full object-cover aspect-[4/5] md:aspect-auto md:h-[480px]"
            />
            <div
              className={`absolute inset-0 ${
                isDark ? "bg-navy/35" : "bg-navy/20"
              } mix-blend-multiply`}
            />
            <div className="absolute inset-0 border border-gold/40" />
            {/* corner details */}
            <div className="absolute top-4 left-4 w-6 h-[1px] bg-gold" />
            <div className="absolute top-4 left-4 w-[1px] h-6 bg-gold" />
            <div className="absolute bottom-4 right-4 w-6 h-[1px] bg-gold" />
            <div className="absolute bottom-4 right-4 w-[1px] h-6 bg-gold" />
          </div>
        </div>

        {/* Text */}
        <div
          className={`md:col-span-6 ${
            imageOnLeft ? "md:col-start-7" : "md:col-start-1 md:row-start-1"
          }`}
        >
          <div className="flex items-center gap-4 mb-6">
            <span
              className={`w-12 h-12 border ${
                isDark ? "border-gold/50" : "border-navy/20"
              } flex items-center justify-center shrink-0 text-gold`}
            >
              <Icon size={20} strokeWidth={1.5} />
            </span>
            <span
              className={`overline ${
                isDark ? "text-gold" : "text-anthracite/70"
              }`}
            >
              Faaliyet Alanı
            </span>
          </div>

          <h2
            className={`font-heading text-3xl md:text-4xl lg:text-5xl font-light tracking-tight leading-tight ${
              isDark ? "text-white" : "text-navy"
            }`}
          >
            {bolum.title}
          </h2>

          <div className="mt-6 w-16 h-[1px] bg-gold" />

          <p
            className={`mt-6 text-base md:text-lg leading-relaxed font-light ${
              isDark ? "text-white/85" : "text-anthracite/85"
            }`}
          >
            {bolum.lead}
          </p>

          <div
            className={`mt-6 space-y-4 text-[15px] leading-relaxed font-light ${
              isDark ? "text-white/70" : "text-anthracite/80"
            }`}
          >
            {bolum.body.map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </div>

          {/* Highlights */}
          <div className="mt-8 flex flex-wrap gap-3">
            {bolum.highlights.map((h) => (
              <span
                key={h}
                className={`inline-flex items-center gap-2 px-4 py-2 text-[11.5px] tracking-[0.2em] uppercase font-medium ${
                  isDark
                    ? "border border-white/20 text-white/85"
                    : "border border-navy/15 text-navy/85"
                }`}
                dangerouslySetInnerHTML={{
                  __html: `<span class="w-1.5 h-1.5 bg-gold"></span>${h}`,
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default function FaaliyetAlanlariPage() {
  useDocumentSEO({
    title: "Faaliyet Alanları",
    description:
      "Mimarlık, inşaat taahhüt, anahtar teslim, gayrimenkul geliştirme, proje yönetimi ve yapı yenileme başlıklarında sunduğumuz hizmetler.",
  });
  return (
    <>
      <PageHeader
        breadcrumb="Faaliyet Alanları"
        overline="Ne Yapıyoruz"
        title="Faaliyet Alanları"
        subtitle="Mimari projelendirmeden gayrimenkul geliştirmeye uzanan altı ana faaliyet alanında; kurumsal disiplin, planlı süreç yönetimi ve mimari bakış açısıyla çözümler sunuyoruz."
        backgroundImage="https://images.pexels.com/photos/1105754/pexels-photo-1105754.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800"
      />

      {/* Overview strip — 6 kart mini-index */}
      <section
        data-testid="faaliyet-index"
        className="bg-white border-b border-navy/5 py-10 lg:py-14"
      >
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <div className="overline text-anthracite/60 mb-6">
            Altı Faaliyet Alanı
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-[1px] bg-navy/10">
            {BOLUMLER.map((b) => (
              <a
                key={b.slug}
                href={`#${b.slug}`}
                data-testid={`faaliyet-index-${b.slug}`}
                className="group bg-white p-5 flex items-center gap-3 hover:bg-navy hover:text-white transition-colors"
              >
                <span className="w-1.5 h-1.5 bg-gold shrink-0 group-hover:bg-white transition-colors" />
                <span className="text-[12.5px] font-medium leading-tight">
                  {b.title}
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* 6 detailed sections */}
      {BOLUMLER.map((bolum, i) => (
        <AlanBolumu key={bolum.slug} bolum={bolum} index={i} />
      ))}

      {/* Bottom CTA — Proje Yaklaşımımız */}
      <section
        data-testid="faaliyet-cta-yaklasim"
        className="bg-navy text-white py-24 lg:py-28 relative overflow-hidden"
      >
        <div className="absolute inset-0 blueprint-grid opacity-30 pointer-events-none" />
        <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-8">
            <div className="overline text-gold mb-5">Bir Sonraki Adım</div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light tracking-tight leading-tight">
              Bu alanlardaki çalışma
              <br />
              biçimimizi merak ediyorsanız —
            </h2>
            <p className="mt-6 max-w-xl text-white/70 leading-relaxed font-light">
              Projeleri hangi süreç ve disiplinle ele aldığımızı; ihtiyaç
              analizinden teslim ve değer yönetimine kadar beş aşamalı
              yaklaşımımızı ayrı bir sayfada inceleyebilirsiniz.
            </p>
          </div>
          <div className="md:col-span-4 md:flex md:justify-end">
            <Link
              to="/proje-yaklasimimiz"
              data-testid="faaliyet-cta-proje-yaklasimi"
              className="group inline-flex items-center gap-3 bg-gold hover:bg-gold-hover text-white px-8 py-4 text-[12.5px] tracking-widest uppercase font-medium transition-colors"
            >
              Proje Yaklaşımımız
              <ArrowRight
                size={16}
                className="transition-transform group-hover:translate-x-1"
              />
            </Link>
          </div>
        </div>
      </section>

      {/* Alt küçük geçiş */}
      <section className="bg-white py-10 border-t border-navy/5">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-[12px] tracking-[0.25em] uppercase text-anthracite/60">
            İletişim
          </div>
          <Link
            to="/iletisim"
            data-testid="faaliyet-next-iletisim"
            className="group inline-flex items-center gap-3 text-navy hover:text-gold transition-colors text-[13px] tracking-widest uppercase font-medium"
          >
            Bir Proje Üzerinde Konuşalım
            <ArrowUpRight
              size={15}
              className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
            />
          </Link>
        </div>
      </section>
    </>
  );
}
